<template>
    <div class="already-box">
        <div class="first">
            <div class="nav-top clearfix">
                <div class="nav-list fr">
                    <van-button class="fr" style="margin-top: 6px;" @click.native="ok">返回</van-button>
                </div>
            </div>
            <!-- 班牌 -->
            <div class="already-box" style="margin-top:10px;" v-if="isNoData">
                <div class="already-list" v-for="(item,i) in ClassTerminalList" :key="item.ClassTerminalID">
                    <div class="already-row">
                        {{item.ClassTerminalName}}
                    </div>
                    <span class="already-del" @click="del(item,i)">删除</span>
                </div>
            </div>
            <div v-else class="no-data-box">
                <img class="no-data-img" src="@/assets/common/moblie-no-data.png" />
                <span class="no-data-text" style="left:0;">
                    暂无已选择的班牌
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Already",
    data() {
        return {        
            type: 0,
            filesUrls: [],
            treeList: [],
            treeListGroup: {},
            isNoData: false,
            ClassTerminalList: [],
            classTerminal: [],
            checkedArr: [],
            imgFile: {},
            formData: '',
            idList: [],
            taskName: '',
            isEdit: false,
            valData:'',
        };
    },
    computed: {

    },
    created () {
        this.type = this.$store.state.infoPublic.typePic;
        this.filesUrls = this.$store.state.infoPublic.PicfilesUrls;
        this.classTerminal = this.$store.state.infoPublic.classTerminal;
        this.treeListGroup = this.$store.state.infoPublic.treeListGroup;
        this.noticeData = this.$store.state.infoPublic.noticeData;
        // 数组id
        this.checkedArr = this.$store.state.infoPublic.checkedArr;
        console.log(this.checkedArr)
        
    },
    mounted () {
        this.loadFirst();
    },
    methods: {
        // 初始
        loadFirst () {
            this.alreadyElement(this.treeListGroup)
            if (this.ClassTerminalList.length > 0) {
                this.isNoData = true;
            } else {
                this.isNoData = false;
            }
            this.loadList();
        },

        // 判断 显示所选的班牌
        alreadyElement (treeList) {
            if (treeList.TreminalS.length > 0) {
                for (var c = 0; c < treeList.TreminalS.length; c++) {
                    if (this.checkedArr.length > 0) {
                        for (var j = 0; j < this.checkedArr.length; j++) {
                            if (treeList.TreminalS[c].ClassTerminalId === this.checkedArr[j]) {
                                this.ClassTerminalList.push(treeList.TreminalS[c])
                            }
                        }
                    } else {
                        return;
                    }
                }
            }
            if (treeList.children.length > 0) {
                for (var i = 0; i < treeList.children.length; i++) {
                    this.alreadyElement(treeList.children[i]);
                }
            }
        },

        // 文件配置
        loadList () {
            if (this.type !== 7) {
                //我们可以预先定义一个FormData对象  
                var formData = new FormData();
                if (this.filesUrls === undefined) {
                    this.isEdit = true;
                } else {
                    for (var i = 0; i < this.filesUrls.length; i++) {
                        // name
                        formData.append("name", this.filesUrls[i].name);
                        // type
                        formData.append("type", this.filesUrls[i].type);
                        // size
                        formData.append("size", this.filesUrls[i].size);
                        // lastModifiedDate
                        formData.append("lastModifiedDate", this.filesUrls[i].lastModifiedDate);
                        // append 文件
                        formData.append("File", this.filesUrls[i]);
                    }
                    this.formData = formData;
                }
            }
        },

        // 取js随机数
        randomn (n) {
            if(n > 21) return null
            var re = new RegExp("(\\d{" + n + "})(\\.|$)")
            var num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(re)[1]
            this.taskName = num;
        },

        // 删除
        del (val, index) {
            this.valData = val;
            //--------------------弹出框---------------------------------------
            // 删除提示 你确定要删除xxx吗？
            this.xy.confirm('删除提示',  '你确定要删除“' + val.ClassTerminalName + '”吗？', () => {
                this.delOk(val, index)
            });
        },
        
        // 删除
        delOk(val,index){
            for (var i = 0; i < this.ClassTerminalList.length; i++) {
                if (val.ClassTerminalId === this.ClassTerminalList[i].ClassTerminalId) {
                    this.ClassTerminalList.splice(index, 1);
                    this.xy.msgSuc('删除成功！');
                    if(this.ClassTerminalList.length > 0) {
                        this.isNoData = true
                    } else {
                        this.isNoData = false
                    }
                }
            }
        },


        // 返回
        ok () {
            var classTerminal = this.ClassTerminalList;
            this.PublishTaskInfo =  this.noticeData;
            this.$store.commit('infoPublic/setPicfilesUrls', this.filesUrls);
            this.$store.commit('infoPublic/setclassTerminal', classTerminal);
            this.$store.commit('infoPublic/settypePic', this.type);
            this.$store.commit('infoPublic/setPublishTaskInfo', this.PublishTaskInfo);
            // this.$router.push('/home/SelectClassCard');
            this.$router.go(-1);
        },
    }
};
</script>
<style lang="less" scoped>
/* 已选班牌 */
.already-box {
    background:#fff;
    height: 100%;
    padding-bottom: 90%;
    overflow: hidden;
}
    .already-box > .already-list {
        height: 100px;
        line-height: 100px;
        border-top: 1px solid #f2f2f2;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        padding: 0 0 0 15px;
    }

        .already-box > .already-list > .already-row {
            display: inline-block;
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }

        .already-box > .already-list > .already-del {
            display: inline-block;
            width: 18%;
            vertical-align: middle;
            text-align: center;
            color: #F85F30;
        }

  .no-data-box {
    width: 74%;
    margin: 160px auto;
    text-align: center;
    font-size: 32px;
    color: #444;
    img{
      width: 100%;
    }
  }

</style>